import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-183" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-4xl" data-id="element-184" data-mp="yto8on8960iw">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-185" data-mp="kx13xya2662f">
          <span aria-hidden="true" data-id="element-186" data-mp="ptho6he500a8">📦 </span>Was steckt im YOGA BEREIT™ Paket?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-187" data-mp="b4vb6mbzfkm6">
          {packItems.map(item => <li key={item.title} className="flex flex-col rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-188" data-mp="fyfz1ljv2y7n">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-189" data-mp="27kxyvfltlem">
                {item.emoji}
              </span>
              <h3 className="mt-4 font-display text-base font-bold text-ink" data-id="element-190" data-mp="3ocyc61ont3y4">{item.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-191" data-mp="3ofau4euf3eb6">{item.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}